/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { toolsetsUpdateBySlug } from "../funcs/toolsetsUpdateBySlug.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { Toolset } from "../models/components/toolset.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpdateToolsetRequest,
  UpdateToolsetSecurity,
} from "../models/operations/updatetoolset.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type UpdateToolsetMutationVariables = {
  request: UpdateToolsetRequest;
  security?: UpdateToolsetSecurity | undefined;
  options?: RequestOptions;
};

export type UpdateToolsetMutationData = Toolset;

export type UpdateToolsetMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * updateToolset toolsets
 *
 * @remarks
 * Update a toolset's properties including name, description, and HTTP tools
 */
export function useUpdateToolsetMutation(
  options?: MutationHookOptions<
    UpdateToolsetMutationData,
    UpdateToolsetMutationError,
    UpdateToolsetMutationVariables
  >,
): UseMutationResult<
  UpdateToolsetMutationData,
  UpdateToolsetMutationError,
  UpdateToolsetMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildUpdateToolsetMutation(client, options),
    ...options,
  });
}

export function mutationKeyUpdateToolset(): MutationKey {
  return ["@gram/client", "toolsets", "updateBySlug"];
}

export function buildUpdateToolsetMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: UpdateToolsetMutationVariables,
  ) => Promise<UpdateToolsetMutationData>;
} {
  return {
    mutationKey: mutationKeyUpdateToolset(),
    mutationFn: function updateToolsetMutationFn({
      request,
      security,
      options,
    }): Promise<UpdateToolsetMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(toolsetsUpdateBySlug(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
